import { render } from "./PostView.vue?vue&type=template&id=29c4a4da"
import script from "./PostView.vue?vue&type=script&lang=js"
export * from "./PostView.vue?vue&type=script&lang=js"

import "./PostView.vue?vue&type=style&index=0&id=29c4a4da&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__